import { useLocation } from 'react-router-dom';
import { ROUTE_MOBILE_QUICK_DEPOSIT } from '~/components/router/constants.js';

const TRANSPARENT_MODAL_ROUTES = [ROUTE_MOBILE_QUICK_DEPOSIT];

const useTransparentModalRoute = () => {
	const location = useLocation();
	return TRANSPARENT_MODAL_ROUTES.find(route => location?.search.includes(route));
};

export default useTransparentModalRoute;
